import { render, staticRenderFns } from "./Retail.template.vue?vue&type=template&id=49e6aaf6&"
var script = {}
import style0 from "./Retail.template.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports